import React from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { AdminNav } from '@bw/alloy-react';
import './Navigation.scss';
import composeURL from 'utils/composeURL';

/** Basic navigation component that shows links in the nav bar. */
const Navigation: React.FC = () => {
  const { authState, oktaAuth } = useOktaAuth();
  if (authState?.isAuthenticated || oktaAuth?.isLoginRedirect()) {
    return null;
  }

  return (
    <AdminNav
      title="Bandwidth"
      items={[
        {
          dataBw: 'login',
          label: 'Log in',
          to: composeURL('/login'),
        },
        {
          dataBw: 'subItem1',
          label: 'Privacy Notice',
          to: 'https://bandwidth.com/privacy',
        },
        {
          dataBw: 'subItem4',
          label: 'Service Status',
          to: 'https://status.bandwidth.com/',
        },
      ]}
      mainContentId="top-nav"
    />
  );
};

export default Navigation;
